import React, { useEffect, useState } from "react";
import InputText from "../common/InputText";
import { useComponent } from "../common/Modal";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners";
import { userlogin } from "../../services/apiServices";
import { useAuthStore } from "../../redux/features/authSlice";
import {
  decryptedValueCrypto,
  encryptedValueCrypto,
} from "../../utils/common-function";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import GoogleAuthButton from "../common/GoogleWrapper";
import { useTranslation } from "react-i18next";

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const { updateLoginInfo, loginInfo } = useAuthStore();
  const [rememberMe, setRememberMe] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const { setCurrentComponent, onClose } = useComponent();
  const { t, i18n } = useTranslation();

  //manual login
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const payload = {
        email: data?.email?.toLowerCase(),
        password: data?.password,
      };
      const response = await userlogin(payload);
      if (response?.data?.statusCode == 200) {
        const userData = {
          user: response?.data?.user,
          token: response?.data?.token,
        };
        updateLoginInfo(userData);
        toast.success(response?.data?.message || "Login successfully.", {
          position: "top-right",
          autoClose: 3000,
        });

        if (rememberMe) {
          localStorage.setItem("userData", await encryptedValueCrypto(payload));
          localStorage.setItem("rememberMe", JSON.stringify(true));
        } else {
          localStorage.removeItem("userData");
          localStorage.removeItem("rememberMe");
        }
        onClose(setCurrentComponent, "");
      } else {
        toast.error(
          response?.data?.message || "Login failed. Please try again.",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.warn("error coming in sign in: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    procesData();
  }, []);

  const procesData = async () => {
    try {
      const storedRememberMe = await JSON.parse(
        localStorage.getItem("rememberMe")
      );
      setRememberMe(storedRememberMe);
      const storedUserData = await localStorage.getItem("userData");

      if (storedRememberMe && storedUserData) {
        const decryptedData = await decryptedValueCrypto(storedUserData);
        if (decryptedData) {
          setValue("email", decryptedData.email);
          setValue("password", decryptedData.password); // Keep password empty for security reasons
        }
      }
    } catch (error) {
      console.warn("error in singin ", error);
    }
  };
  // **🔹 Handle Remember Me Checkbox**
  const onChangeRemember = (e) => {
    setRememberMe(e.target.checked);
  };

 
  return (
    <div className="w-full">
      <h2 className="text-2xl text-primary-text font-semibold text-center">
        {t("signin_welcome")}
      </h2>

      <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
        {t("signin_enter_details")}
      </h5>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputText
          title={t("signin_email")}
          placeholder={t("signin_email_placeholder")}
          type="email"
          {...register("email", {
            required: t("signin_email_required"),
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: t("signin_email_invalid"),
            },
          })}
          error={errors.email?.message}
          value={watch("email")}
          onChange={(e) => {
            setValue("email", e.target.value);
            trigger("email");
          }}
        />

        <InputText
          title={t("signin_password")}
          placeholder={t("signin_password_placeholder")}
          type="password"
          password={true}
          {...register("password", {
            required: t("signin_password_required"),
            minLength: {
              value: 6,
              message: t("signin_password_minlength"),
            },
          })}
          error={errors.password?.message}
          value={watch("password")}
          onChange={(e) => {
            setValue("password", e.target.value);
            trigger("password");
          }}
        />

        <div className="flex justify-between items-center mt-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={rememberMe}
              className="accent-[#164E63] w-[18px] h-[18px] rounded-[15px]"
              onChange={(e) => onChangeRemember(e)}
            />

            <label className="ms-2 text-base font-semibold text-primary-text">
              {t("signin_remember_me")}
            </label>
          </div>

          <p
            onClick={() => setCurrentComponent("forgotPassword")}
            className="text-base cursor-pointer font-semibold text-secondary"
          >
            {t("signin_forgot_password")}
          </p>
        </div>

        <div className="mt-6">
          <button className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold">
            {loading ? <ClipLoader size={20} color="#fff" /> : t("signin_continue")}
          </button>
        </div>

        <div className="mt-3">
          <p
            onClick={() => setCurrentComponent("signUp")}
            className="text-center text-lg underline cursor-pointer font-semibold text-red-600"
          >
            {t("signin_signup")}
          </p>
        </div>
      </form>
    </div>
  );
};

export default SignIn;
